import { ConfirmUpdateModalContent } from '@framework/common-web/schema/modules/utils/confirm-update/ConfirmUpdateModalContent.tsx';
import { useTriggerableModulesConfirmUpdate } from '@framework/common-web/schema/modules/utils/confirm-update/useTriggerableModulesConfirmUpdate.tsx';
import { useTranslation } from 'react-i18next';

/**
 * Gestisce la richiesta (modal) di conferma per l'aggiornamento della
 * di un modulo che potrebbe andare ad impattare su altre domande attraverso
 * l'attivazione di moduli dinamici.
 */
export function useSubmissionConfirmUpdate() {
  const { t } = useTranslation();

  const confirmUpdate = useTriggerableModulesConfirmUpdate({
    title: t(
      'submission-confirm-update.conferma-modifiche',
      'Conferma modifiche attivazioni moduli',
    ),
    content: differences => (
      <ConfirmUpdateModalContent
        differences={differences}
        content={t(
          'submission-confirm-update.conferma-aggiornamento-modulo',
          'Confermi di voler aggiornare il modulo?',
        )}
      />
    ),
  });

  return confirmUpdate;
}
